export default "__VITE_ASSET__DshaYwdR__"